export default "__VITE_ASSET__DpVoiAy7__"